import { render } from "./qlc.vue?vue&type=template&id=a5c89224&scoped=true"
import script from "./qlc.vue?vue&type=script&lang=js"
export * from "./qlc.vue?vue&type=script&lang=js"

import "./qlc.vue?vue&type=style&index=0&id=a5c89224&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c89224"]])

export default __exports__